import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResetPasswordComponent, SetPasswordComponent, UnsubscriptionComponent } from '@authentication/components';
import { CanActivateRouteService } from '@encomply/core/services/canactivateroute/canactivateroute.service';

import { RedirectComponent } from './components/redirect/redirect.component';

export const ROUTES: Routes = [
    {
        path: 'auth',
        pathMatch: 'prefix',
        loadChildren: async () => (await import('@authentication/app.module')).AppModule,
        data: {
            secured: false,
        },
    },
    {
        path: 'redirect',
        pathMatch: 'full',
        component: RedirectComponent,
        data: {
            secured: false,
            name: 'Success Redirect',
        },
    },
    {
        path: 'users/activate',
        component: SetPasswordComponent,
        pathMatch: 'full',
        runGuardsAndResolvers: 'always',
        canActivate: [CanActivateRouteService],
        data: {
            secured: false,
            name: 'Set Password',
            skipSession: true,
        },
    },
    {
        path: 'users/changepassword',
        component: ResetPasswordComponent,
        pathMatch: 'full',
        canActivate: [CanActivateRouteService],
        runGuardsAndResolvers: 'always',
        data: {
            secured: false,
            name: 'Reset Password',
            skipSession: true,
        },
    },
    {
        path: 'unsubscribe',
        component: UnsubscriptionComponent,
        pathMatch: 'full',
        data: {
            secured: false,
            name: 'Email Unsubscription',
            hideHeader: true,
        },
    },
    {
        path: 'enreport',
        pathMatch: 'prefix',
        loadChildren: async () => (await import('@enreport/app.module')).AppModule,
        data: {
            secured: true,
        },
    },
    {
        path: 'collaboration',
        pathMatch: 'prefix',
        loadChildren: async () => (await import('@eninvoice-guest/guest.module')).GuestModule,
        data: {
            secured: false,
        },
    },
    {
        path: 'eninvoice',
        pathMatch: 'prefix',
        loadChildren: async () => (await import('@eninvoice/app.module')).AppModule,
        data: {
            secured: true,
        },
    },
    {
        path: 'encollab',
        pathMatch: 'prefix',
        loadChildren: async () => (await import('@encollab/app.module')).AppModule,
        data: {
            secured: true,
        },
    },
    {
        path: 'enreconcile',
        pathMatch: 'prefix',
        loadChildren: async () => (await import('@enreconcile/app.module')).AppModule,
        data: {
            secured: true,
        },
    },
    {
        path: 'gst-filing',
        pathMatch: 'prefix',
        loadChildren: async () => (await import('@gst-filing/app.module')).AppModule,
        data: {
            secured: true,
        },
    },
    {
        path: 'custom',
        pathMatch: 'prefix',
        loadChildren: async () => (await import('@custom/custom.module')).CustomModule,
        data: {
            secured: true,
        },
    },
    {
        path: '',
        loadChildren: async () => (await import('@encomply/app.module')).AppModule,
        data: {
            secured: true,
        },
    },
];

@NgModule({
    imports: [RouterModule.forRoot(ROUTES, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
